export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const GET_USER_WALLET_BALANCE = 'GET_USER_WALLET_BALANCE';

export const SET_USER_BORROWS = 'SET_USER_BORROWS';

export const SET_AGREEMENTS_LOADING_FALSE = 'SET_AGREEMENTS_LOADING_FALSE';
export const FETCH_AGREEMENTS_FROM_CONTRACT = 'FETCH_AGREEMENTS_FROM_CONTRACT';

export const SET_LENDER_AGREEMENTS = 'SET_LENDER_AGREEMENTS';
export const SET_BORROWER_AGREEMENTS = 'SET_BORROWER_AGREEMENTS';

export const SET_NO_WALLET_INFO_FOR_AGREEMENTS = 'SET_NO_WALLET_INFO_FOR_AGREEMENTS';
